import apiMiddleware from "../middleware/api";
import actionArrayMiddleware from "../middleware/actionArray";
import wsMiddleware from "../middleware/ws";
import { configureStore } from "@reduxjs/toolkit";
import createReducers from "../reducers";

export default function configStore() {
	const store = configureStore({
		reducer: createReducers(),
		middleware: getDefaultMiddleware => {
			const middlewares = getDefaultMiddleware({
				// https://github.com/reduxjs/redux-toolkit/issues/415
				immutableCheck: false,
				serializableCheck: false
			});
			middlewares.push(apiMiddleware);
			middlewares.push(actionArrayMiddleware);
			middlewares.push(wsMiddleware);

			return middlewares;
		}
	});

	return store;
}
